<template>
    <div :class="classes"><slot /></div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class WorkScheduleContainerRow extends Vue {
        @Prop({type: Boolean}) public stickyTop!: boolean;

        public get classes(): Record<string, boolean> {
            return {
                workScheduleContainerRow: true,
                stickyTop: this.stickyTop,
            };
        }
    }
</script>

<style scoped lang="scss">
    .workScheduleContainerRow {
        display: grid;
        grid-column: 1 / -1;
        grid-template-columns: subgrid;

        &.stickyTop {
            position: sticky;
            top: 0;
            z-index: 100;
        }
    }
</style>
